export const ENROLLMENT_COHORT_STATUS_KEYS = [
  "new_referral",
  "enrollment_scheduled",
  "awaiting_additional_referral_information",
  "additional_call_to_be_scheduled",
  "enrollment_missed",
  "interested",
  "not_currently_interested",
  "unresponsive_to_multiple_calls",
  "explicitly_not_interested",
  "do_not_call",
  "duplicate_account",
  "invalid_phone_number",
  "no_longer_in_care_with_provider",
  "unrecorded",
  "assessed",
  "submitted",
  "pending",
  "review",
  "aligned",
  "unaligned",
  "not_eligible",
] as const;

export type EnrollmentCohortStatusKey = (typeof ENROLLMENT_COHORT_STATUS_KEYS)[number];

export type EnrollmentCohortStatusOptions = {
  asOf: string;
  throughDate: string;
  clinics: { id: string; name: string; months: string[] }[];
  source: "live";
};

/** Aggregate daily counts; patient identifiers and histories never leave the control plane. */
export type EnrollmentCohortStatusResponse = {
  asOf: string;
  throughDate: string;
  month: string;
  clinicIds: string[];
  cohortSize: number;
  fullyObservedDays: number | null;
  points: {
    day: number;
    observed: number;
    counts: { status: EnrollmentCohortStatusKey; count: number }[];
  }[];
  source: "live";
};
